const messages = {
    en: {
      consent: "This site uses cookie to provide you with a great user experience",
      agree: "Agree",
      details: "Details..."
    },
    ru: {
      consent: "Этот сайт использует файлы cookie для вашего удобства",
      agree: "Согласeн",
      details: "Подробности..."
    }
  };

  export default messages;